import { c as _c } from "react/compiler-runtime";
import { SvgIcon } from '@mui/material';
const FilterIcon = t0 => {
  const $ = _c(3);
  const {
    sx
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fill="white" d="M12.081 17.7685H7.91898V12.8333C7.91898 12.6158 7.82214 12.4095 7.65476 12.2706L2.23148 7.7677V2.23148H17.7685V7.7677L12.3452 12.2706C12.1779 12.4095 12.081 12.6158 12.081 12.8333V17.7685Z" stroke="black" strokeWidth="1.46295" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== sx) {
    t2 = <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" sx={sx}>{t1}</SvgIcon>;
    $[1] = sx;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default FilterIcon;